import React from "react";
import {  Grid  } from "semantic-ui-react";
import { SearchPort } from "@commonComponents/dropdown/Ports";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import { useSelector } from "react-redux";
import { selectHeaderTabDS } from "@EUForms/selectors";
const descripenciesList = [
  { id: 'idx1', text: 'Yes', value: '1', text_es:'Sí' },
  { id: 'idx2', text: 'No', value: '0', text_es:'No' },
]
export const CountryInfoForm = React.memo(
  ({
    dataSource,
    isDiscrepanciesExist,
    onHeaderDataSelect,
    countryList,
    onSelect,
    renderAtFirst,
    renderAtLast,
  }) => {
    const { originCountry, destinationCountry, placeOfLoading, placeOfUnloading } = dataSource
    const transmissionType = useSelector(selectHeaderTabDS)?.transmissionType

    return (
      <Grid.Row>
        {renderAtFirst && renderAtFirst()}
        <Grid.Column>
          <DropDown
            id='originCountry'
            boxNumber='5/14'
            label='COUNTRY_DISPATCH'
            name='originCountry'
            data={countryList}
            value={originCountry}
            text={originCountry}
            onChange={onSelect}
          />
        </Grid.Column>
        <Grid.Column>
          <SearchPort
            boxNumber='5/21'
            id='loadingPlace'
            name='placeOfLoading'
            condition={originCountry}
            label='PLACE_OF_LOADING'
            selectedValue={placeOfLoading}
            onSelect={({ portUnloc, freightPercent }) => {
              onSelect(null, {
                value: portUnloc,
                name: 'placeOfLoading',
                freightPercent: freightPercent || '',
              })
            }}
            onBlur={({ value }) => {
              if (!value) {
                onSelect(null, { value, name: 'placeOfLoading' })
              }
            }}
          ></SearchPort>
        </Grid.Column>

        <Grid.Column>
          <DropDown
            id='destinationCountry'
            boxNumber='5/8'
            clearable
            label='COUNTRY_OF_DESTINATION'
            name='destinationCountry'
            data={countryList}
            value={destinationCountry}
            text={destinationCountry}
            onChange={onSelect}
          />
        </Grid.Column>

        <Grid.Column>
          <SearchPort
            id='unLoadingPlace'
            condition={destinationCountry}
            label='PLACE_OF_UNLOADING'
            selectedValue={placeOfUnloading}
            boxNumber='5/22'
            onSelect={({ portUnloc }) => {
              onSelect(null, { value: portUnloc, name: 'placeOfUnloading' })
            }}
            onBlur={({ value }) => {
              if (!value) {
                onSelect(null, { value, name: 'placeOfUnloading' })
              }
            }}
          />
        </Grid.Column>
        {transmissionType === 'NOT' && (
          <Grid.Column>
            <DropDown
              id='descripencies'
              name='isDiscrepanciesExist'
              clearable
              label='DESCREPENSIES'
              data={descripenciesList}
              onChange={onHeaderDataSelect}
              text={isDiscrepanciesExist}
              value={isDiscrepanciesExist}
            />
          </Grid.Column>
        )}
        {renderAtLast && renderAtLast(dataSource)}
      </Grid.Row>
    )
  }
)

CountryInfoForm.defaultProps = {
  translate:(value)=>value,
  dataSource:{}
}